import { render, staticRenderFns } from "./measurements.chart.vue?vue&type=template&id=070c5df6&"
import script from "./measurements.chart.vue?vue&type=script&lang=js&"
export * from "./measurements.chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports